
import Model from './model';
import config from './../config';
import state from './../zviz2/zviz/state';
import ModelCollection from './../zviz2/zviz/modelcollection';
import {extend} from './../zviz2/zviz/functions';

class Filter extends Model{

    constructor(name=null, settings={}){
        
        settings = extend(settings, {
            endpoint: config.root + 'filter',
            method: 'GET',
            listeners: [
                (model) => ( model.addListener(state, [model, model.update], 'filter') ),
                (model) => ( model.addListener(state, [model, model.update], 'source') )
            ]
        });
        
        super(name, settings);

        this.cache = new Map();

        this.result = {};

        this.update();
    }
    
    getSelect(){
        let input = {};
        let source = state.get('source');
        if(source == 'll'){
            input['countField'] = 'll_id';
        }else if(source == 'gp'){
            input['countField'] = 'gp_id';
        }else if(source == 'rec'){
            input['countField'] = 'rec_id';
        }else{
            input['countField'] = 'eval_id';
        }

        let f = state.get('filter') || {};
        f['planned_flag'] = true; // set the right value in processFilter
        if(f.year){
            f['eval_rpt_end_year'] = f.year.slice(0);
            delete f.year;
        }
        // Not sure why we had this, doesn't seem to be required and looks weird in the active filters.
        // Removing it for now
        // if(! f[input['countField']]){
        //     f[input['countField']] = '__NOT_EMPTY__';
        // }
        input['filter'] = this.processFilter(f);
        // Applying search on this request is potentially heavy, while it has limited value. We may consider
        // dropping it.
        this.processSearch(input, f);

        input['aggregateBy'] = (['eval_rpt_end_year', 'theme_category', 'theme', 'country', 'funding_source',
                'region', 'subject_expertise_title', 'eval_type', 'eval_timing', 'eval_nature',
                'rec_theme_category', 'rec_theme','gp_theme_category', 'gp_theme',
                'll_theme_category', 'll_theme']).join(',');
        
        return input;
    } 

    getDataFromResponse(input){

        input = super.getDataFromResponse(input);

        if(input == null){
            return null;
        }

        this.result = {};
        if(input['items']){
            for(let key of Object.keys(input['items'])){
                let k = key;
                if(key == 'eval_rpt_end_year'){
                    // create an array of available years and check if the current filter set in the state is
                    // included in the options. Otherwise reset the year in the state. Its a little bit of a
                    // cumbersome method and I believe there could be different similar logic in the elsewhere
                    // in the application too. So this is a little hacky...
                    const rangeYears = [];
                    for(const item of input['items'][key]){
                        rangeYears.push(item.v);
                    }
                    rangeYears.sort();
                    let years = state.get('filter.year') || [];
                    if(! (years instanceof Array)){
                        years = [years];
                    }
                    years.sort();
                    if(years.length > 0 && rangeYears.length > 0){
                        const min = years[0] < rangeYears[0] ?
                                rangeYears[0] : Math.min(years[0], rangeYears[rangeYears.length - 1]);
                        const max = years[years.length - 1] > rangeYears[rangeYears.length - 1] ?
                                rangeYears[rangeYears.length - 1] : Math.max(years[years.length - 1], min);
                        if(min !== years[0] || max !== years[years.length - 1]){
                            const newRange = [];
                            for(let y = min; y <= max; y++){
                                newRange.push(y);
                            }
                            state.set('filter.year', newRange);
                        }
                    }
                    k = 'year';
                }
                this.result[k] = input['items'][key]; 
            }
        }
        return this.result;
    }

    getCache(){
        let success = super.getCache();
        if(success){
            this.result = this.data;
        }
        return success;
    }


}

ModelCollection.setModelClass('filter', Filter);

export default Filter;